import React from 'react';
import { Box, Divider, Paper, Stack, Typography } from '@mui/material';

import { InvoicesFilters } from './InvoicesFilters';
import { InvoicesTable } from './InvoicesTable';
import { InvoicesProvider } from './InvoicesContext';
import { InvoicesPagination } from './InvoicesPagination';
import { NoInvoicesWrapper } from './NoInvoicesWrapper';

export const InvoicesPage = () => {
  return (
    <Paper>
      <Box sx={{ p: 5 }}>
        <Typography variant="h2">Meine Rechnungen</Typography>
      </Box>
      <Divider />
      <Box sx={{ p: 5 }}>
        <Stack spacing={5}>
          <InvoicesProvider>
            <NoInvoicesWrapper>
              <InvoicesFilters />
              <InvoicesTable />
              <InvoicesPagination />
            </NoInvoicesWrapper>
          </InvoicesProvider>
        </Stack>
      </Box>
    </Paper>
  );
};
